function LoadingMessage({ message }) {
    return (
        <div className="loading-message" role="status" aria-live="polite">
            {message}
        </div>
    );
}

export default LoadingMessage;